import React from "react";
// nodejs library that concatenates classes
import classNames from "classnames";
// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";
// @material-ui/icons
// import Separator from "@material-ui/icons/LinearScale";
import Bullet from "@material-ui/icons/DragIndicator";
// core components
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import InfoArea from "components/InfoArea/InfoArea.jsx";

import servicesStyle from "assets/jss/material-kit-pro-react/views/aboutUsSections/servicesStyle.jsx";

function SectionServices(props) {
  const { classes } = props;
  return (
    <div className={classes.services}>
      <GridContainer>
        <GridItem
          md={8}
          sm={8}
          className={classNames(
            classes.mlAuto,
            classes.mrAuto,
            classes.textCenter
          )}
        >
          <h2 className={classes.title}>What we offer</h2>
          <h5 className={classes.description}>
            Research
          </h5>
        </GridItem>
      </GridContainer>

      <GridContainer>
        <GridItem md={6} sm={6}>
          <InfoArea
            title="Get all the insights you need in one single place."
            description={
              <span>
                <p>
                  Optimise your investment processes, promotion and valuation of assets with research Intelligence.
                  With Kinos you can to access to platform with all information of your assets.
                </p>

              </span>
            }
            icon={Bullet}
            iconColor="rose"
          />
        </GridItem>

        <GridItem md={6} sm={6}>
          <InfoArea
            title="Automate real estate analysis, valuation and forecast, leveraging on big data and machine learning."
            description={
              <span>
                <p>
                  Automate real estate analysis, valuation and forecast, leveraging on big data and machine learning.
                  Show the value of your assets Conduct comprehensive market analysis and analyse purchasing trends to determine an accurate valuation of your assets.
                </p>

              </span>
            }
            icon={Bullet}
            iconColor="rose"
          />
        </GridItem>

        <GridItem md={6} sm={6}>
          <InfoArea
            title="Anticipate market dynamics and urban evolutions."
            description={
              <span>
                <p>
                  Boost your real estate promotion
                  Understand what assets to develop in each place, identify the target customers and carry out promotions optimised for each potential client.

                </p>

              </span>
            }
            icon={Bullet}
            iconColor="rose"
          />
        </GridItem>
        <GridItem md={6} sm={6}>
          <InfoArea
            title="Identify high potential investment opportunities."
            description={
              <span>
                <p>
                  Identify investment opportunitiesDiscover where to buy or sell your assets, find emerging markets and analyse your real estate assets in a matter of seconds.
                </p>

              </span>
            }
            icon={Bullet}
            iconColor="rose"
          />
        </GridItem>

        <GridItem md={6} sm={6}>
          <InfoArea
            title="Investment strategies"
            description={
              <span>
                <p>
                  <ul>
                    <li>Management of JV or Development Process</li>
                    <li>Financial Operating Modelling</li>
                    <li>Budgeting and control</li>
                    <li>Legal Structuring and Specifications</li>
                    <li>Tech-Enabled Interaction</li>
                    <li>Financial Reporting</li>
                    <li>Operation Reporting</li>
                    <li>Marketing Strategy</li>
                    <li>Sales Strategy</li>
                    <li>Life Cycle Cost Analysis</li>
                    <li>Asset Positioning</li>
                    <li>Exit Strategy</li>
                  </ul>
                </p>

              </span>
            }
            icon={Bullet}
            iconColor="rose"
          />
        </GridItem>
        <GridItem md={6} sm={6}>
          <InfoArea
            title="Investment channels"
            description={
              <span>
                <p>
                  <ul>
                    <h6>Direct Investments</h6>
                    <li>In real estate assets </li>
                    <li>In projects</li> 
                    <h6>Through Intermediaries</h6>
                    <li>InvestmentManagers </li>
                    <li>Private equity funds </li>
                    <li>Infrastructure funds</li> 
                    <li>Socimis</li> 
                    <li>Reits</li> 
                    <h6>Other pooled investment vehicles...</h6>
                  </ul>
                </p>

              </span>
            }
            icon={Bullet}
            iconColor="rose"
          />
        </GridItem>



      </GridContainer>
    </div>
  );
}



export default withStyles(servicesStyle)(SectionServices);
